import React from 'react';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';

const EsgList = ({ columns, rows, loading, handleRowClick, columnVisibilityModel }) => {
  const [pageSize, setPageSize] = React.useState(20);

  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 240px)' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: 'ESG 리스트' },
          }}
          loading={loading}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
          rowHeight={80}
          onRowClick={(params, e) => handleRowClick(e, params)}
          columnVisibilityModel={columnVisibilityModel || []}
          sx={{
            // 셀은 flex 가 아니다. 글자 높이를 행 높이만큼 늘려 가운데로 보이게 하는 방식이다.
            // renderCell 이 자기 글자 높이를 가진 컴포넌트(Typography 등)를 돌려주면
            // 그 방식이 안 먹어서 내용이 셀 천장에 붙는다. 행이 높을수록 티가 난다.
            // 셀을 flex 로 두고 직접 가운데 정렬한다.
            '& .MuiDataGrid-cell': {
              display: 'flex',
              alignItems: 'center',
            },
          }}
        />
      </div>
    </div>
  );
};

export default EsgList;
